import {initProductSort} from './Plugins/ProductSort';
import {initScrollToAnchor} from './Plugins/ScrollToAnchor';
import {initLimitSelect} from './Plugins/LimitSelect';
import {initLeasing} from './Modules/Leasing';
import {NewsletterSelectAllInit} from './Modules/Newsletter';
import {initVoucher} from './Plugins/Voucher';
import './globals';
import {initFixedFilters} from './Plugins/FixedFilters';
import {initUserListSelect} from "./Plugins/UserListSelect";
import PageLoadedQueue from "./PageLoadedQueue";
import {initLoadNextProducts} from "./Plugins/LoadNextProducts";
import {initMainMenu} from "../../../Fusion/Component/Atom/MainMenu/MainMenu";
import {
    initPruneList
} from "LocalPackages/Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/Modules/List/PruneList";
import {
    initAdSource
} from "LocalPackages/Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/Modules/AdSource";
import {initOpenChatbot} from "Packages/Plugins/Avency.MercuryAi/Resources/Private/Assets/JavaScript/OpenChatbot";
import {
    scrollToTop
} from "LocalPackages/Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/Plugins/ScrollToTop";

export function initPrices() {
    $('*[data-annotations]').annotations();
    $('.price-async').prices();
    $('.shopping-button-async').shoppingButton();
    $('*[data-fetch-article-buy]').articleBuy();
}

/**
 * Initialize productFilters
 */
export function initProductFilters() {
    $('[data-product-filters="true"]').productFilters();
}

/**
 * Initialize categoryTree
 */
export function initCategoryTree() {
    $('.category-tree').categoryTree();
}

/**
 * Initialize ERPShoppingBasket
 */
export function initErpShoppingBasket() {
    $('[data-query-erp="1"]').erpShoppingBasket();
}

/**
 * Mark searchWord
 */
export function initMarkSearchWord() {
    $(document.body).markSearchWord();
}

/**
 * Initialize DateTimePicker
 */
export function initDateTimePicker() {
    $('[data-datetimepicker]').dateTimePicker();
    $('[data-datetimepicker-formbuilder]').each(function () {
        $(this).dateTimePicker($(this).data('config'));
    });
    $('[data-datepicker]').dateTimePicker({format: 'DD.MM.YYYY'});
}

/**
 * Initialize FormScripts
 */
export function initFormScripts() {
    $('form').formScripts();
}

/**
 * Initialize customer conditions
 */
export function initCustomerConditions() {
    $('.customer-conditions').customerConditions();
}

/**
 * Initialize punch-out submit
 */
export function initPunchOut() {
    $(document.body).punchOut();
}

export function initializeAll() {
    initPrices();
    initMainMenu();
    initProductFilters();
    initFixedFilters();
    initUserListSelect();
    initCategoryTree();
    initErpShoppingBasket();
    initMarkSearchWord();
    initLeasing();
    initScrollToAnchor();
    initProductSort();
    initLimitSelect();
    initVoucher();
    initDateTimePicker();
    initFormScripts();
    initCustomerConditions();
    initPunchOut();
    NewsletterSelectAllInit();
    initLoadNextProducts();
    initPruneList();
    initAdSource();
    initOpenChatbot();
    scrollToTop();
}

PageLoadedQueue.addFunction(initializeAll);
